import React from "react";
import PropTypes from "prop-types";

export const UpArrow = ({ color = "#333" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M3 12L9 6L15 12"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

UpArrow.propTypes = {
  color: PropTypes.string,
};
